import {
    Table,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
    Checkbox,
    Tooltip
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { selectEndorsmentFormData, updateSumInsuredSectionData } from 'src/features/rfqDataSlice';

function EmployeeListItemVertical({ sumInsuredData, tableListDatas, groupDetails }) {
    const dispatch = useDispatch();
    const sectionId = sumInsuredData.id;
    const groupId = groupDetails.id;

    const [selectedHeads, setSelectedHeads] = useState([]);
    const endorsementFormData = useSelector(selectEndorsmentFormData);

    useEffect(() => {
        // Whenever selectedHeads change, update Redux with sumInsuredEntry
        const hasSelectedHeads = selectedHeads.length > 0;

        dispatch(updateSumInsuredSectionData({
            sumInsuredSectionData: {
                [sectionId]: {
                    groups: {
                        [groupId]: {
                            verticalView: true,
                            sumInsuredSelectedHeads: selectedHeads,
                            sumInsuredEntry: hasSelectedHeads ? tableListDatas : [],
                            id: groupId
                        }
                    }
                }
            }
        }));
    }, [selectedHeads, tableListDatas, dispatch, sectionId, groupId]);

    const handleHeadCheckboxChange = (attribute, checked) => {
        setSelectedHeads(prev =>
            checked
                ? [...prev, attribute]
                : prev.filter(attr => attr !== attribute)
        );
    };


    return (
        <TableContainer sx={{ mt: 0 }}>
            <Table
                size="small"
                aria-label="a dense table"
                className="sum_insured_table"
            >
                {sumInsuredData?.sumInsuredHeaderSorted.map((head, rowIndex) => {
                    const attr = head.sumInsuredHeader.attribute;
                    const title = head.title || head.sumInsuredHeader.title;
                    const isChecked = selectedHeads.includes(attr);

                    const isEditableAllowed =
                        endorsementFormData?.type === 'Both' ||
                        (endorsementFormData?.type === 'Financial' &&
                            head?.endorsementSubTypes?.financial?.includes(endorsementFormData?.subType)) ||
                        (endorsementFormData?.type === 'NonFinancial' &&
                            head?.endorsementSubTypes?.nonFinancial?.includes(endorsementFormData?.subType));

                    return (

                        <TableRow key={rowIndex} style={{ height: '40px' }}>
                            <TableCell style={{ width: '480px', paddingLeft: '8px' }}>
                                <div>
                                    {!isEditableAllowed ? (
                                        <Tooltip title="Editing disabled due to subtype restriction">
                                            <span>
                                                <Checkbox
                                                    disabled
                                                />
                                            </span>
                                        </Tooltip>
                                    ) : (
                                        <Checkbox
                                            checked={isChecked}
                                            onChange={(e) =>
                                                handleHeadCheckboxChange(attr, e.target.checked)
                                            }
                                            style={{ paddingTop: '0px', paddingBottom: '0px' }}
                                        />)}
                                    {title}
                                </div>
                            </TableCell>

                            {tableListDatas?.map((rowData, index) => {
                                const value = rowData[attr];

                                const formattedValue = (() => {
                                    if (!value || (Array.isArray(value) && value.length === 0)) return 'N/A';
                                    const dateFields = ['dob', 'dobOfMamber', 'dateOfCoverage'];
                                    if (dateFields.includes(attr)) {
                                        return moment(value).format('DD-MM-YYYY');
                                    }
                                    if (Array.isArray(value)) {
                                        return value.join(', ');
                                    }
                                    return value;
                                })();

                                return (
                                    <TableCell className="Pad3" key={`${attr}-${index}`}>
                                        {formattedValue}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    );
                })}

                {parseFloat(groupDetails.totalSumInsured) > 0 && sumInsuredData.showTotalSumInsured ? (
                    <TableRow>
                        <TableCell className='Pad3'>
                            <Typography variant="h5" style={{ marginTop: 9, textAlign: 'right' }}>
                                Total
                            </Typography>
                        </TableCell>
                        <TableCell className='Pad3'>
                            <Typography variant="h5" style={{ marginTop: 9, textAlign: 'left' }}>
                                : {groupDetails.totalSumInsured ? parseFloat(groupDetails.totalSumInsured)?.toFixed(2) : '0.00'}
                            </Typography>
                        </TableCell>
                    </TableRow>
                ) : null}
            </Table>
        </TableContainer>
    );
}

export default EmployeeListItemVertical;
